module.exports = __webpack_public_path__ + "img/hvid_glogg_spices.02bb77a8.jpg";